import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import ProtectedLayout from '../components/Layouts/ProtectedLayout';
import storage from '@utils/storage';
import Notification from '@pages/Notification/Notification';
import InactivityLogout from '@components/Layouts/InactivityLogout';

type ProtectedRoutesProps = object;

const ProtectedRoutes: React.FC<ProtectedRoutesProps> = () => {
  const location = useLocation();
  const isUserloggedIn = !!storage.getToken();

  if (!isUserloggedIn) {
    return <Navigate to="/auth/login" state={{ from: location }} replace={true} />;
  }

  return (
    <ProtectedLayout>
      <InactivityLogout>
        <Outlet />
        <Notification />
      </InactivityLogout>
    </ProtectedLayout>
  );
};
export default ProtectedRoutes;
